import React from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import Selector from 'react-select';
import { FaSearch } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function FiltrosRelatorio({
  onSubmit,
  isLoading,
  opcoesEmpreendimentos,
  opcoesCorretores,
}) {
  const optionsEmps = (opcoesEmpreendimentos || []).map(item => ({
    value: item.codigo,
    label: item.descricao,
  }));

  const optionsCors = (opcoesCorretores || []).map(item => ({
    value: item.codigo,
    label: item.descricao,
  }));

  const initialValues = {
    codigo_empreendimento: null,
    nome_empreendimento: '',
    quadra: '',
    lote: '',
    codigo_corretor: null,
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ values, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="align-items-end mb-2">
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Empreendimento:</Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      options={optionsEmps}
                      isClearable
                      placeholder="Selecione um empreendimento..."
                      value={optionsEmps.find(o => o.value === values.codigo_empreendimento) || null}
                      onChange={option => {
                        setFieldValue('codigo_empreendimento', option ? option.value : null);
                        setFieldValue('nome_empreendimento', option ? option.label : '');
                      }}
                      noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md={1}>
                  <Form.Group>
                    <Form.Label>Quadra:</Form.Label>
                    <Form.Control
                      type="text"
                      value={values.quadra}
                      onChange={e => setFieldValue('quadra', e.target.value)}
                      placeholder="Quadra"
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md={1}>
                  <Form.Group>
                    <Form.Label>Lote:</Form.Label>
                    <Form.Control
                      type="text"
                      value={values.lote}
                      onChange={e => setFieldValue('lote', e.target.value)}
                      placeholder="Lote"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Corretor:</Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      options={optionsCors}
                      isClearable
                      placeholder="Selecione um corretor..."
                      value={optionsCors.find(o => o.value === values.codigo_corretor) || null}
                      onChange={option =>
                        setFieldValue('codigo_corretor', option ? option.value : null)
                      }
                      noOptionsMessage={() => 'Nenhum corretor encontrado'}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Button
                      type="submit"
                      variant="success"
                      block
                      disabled={isLoading}
                    >
                      <FaSearch /> Buscar
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
}
